import * as a from "./action";
// import { sendMessage } from "../Notifications";
// import { startLoading, stopLoading } from "../Suspense";

const { setLiabilities } = a;

export const fetchLiabilities =
  () =>
  async (dispatch, getState, { history, remote }) => {
    // dispatch(startLoading());

    try {
      const liabilities = await remote(
        "get",
        `v3/customers/liabilities`,
        {},
        "get Liabilities cards",
        dispatch
      );

      dispatch(setLiabilities(liabilities));
    } catch (error) {
      // dispatch(sendMessage("Failed to fetch liabilities"));
    }

    // dispatch(stopLoading());
  };
